import React from 'react';

export type BuyerContextData = {
    hasCustomBackgroundColor: boolean;
};

export const BuyerContext = React.createContext<BuyerContextData>({
    hasCustomBackgroundColor: false,
});
